import { mockSuccess, listPayload } from './shared';
import type { MockRouteEntry } from '../mock-api.types';

const ROWS = [
    { id: 'mock-1', title: 'INV-2026-014', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-2', title: 'INV-2026-013', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
    { id: 'mock-3', title: 'Quote Q-882', status: 'draft', updated_at: '2026-06-04T12:00:00Z' },
];

export const BILLING_MOCK_HANDLERS: MockRouteEntry[] = [
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/billing\/invoices(\?|$)/i,
        handler: () => mockSuccess(listPayload(ROWS)),
    },
    {
        method: 'GET',
        pattern: /\/api\/[^/]+\/[^/]+\/billing\/invoices\/([^/?]+)/i,
        handler: (req) => {
            const match = req.url.match(/\/invoices\/([^/?]+)/i);
            const id = match ? match[1] : '';
            const row = ROWS.find((r) => r.id === id) ?? ROWS[0];
            return mockSuccess(row);
        },
    },
];
